import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as PropTypes from "prop-types";
import { SearchkitComponent, RenderComponentPropType, renderComponent, DynamicRangeAccessor } from "../../../../core";
import { Panel, RangeSlider } from "../../../ui";

var defaults = require("lodash/defaults");

var get = require("lodash/get");

var identity = require("lodash/identity");

export var DynamicRangeFilter =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(DynamicRangeFilter, _SearchkitComponent);

  function DynamicRangeFilter(props) {
    var _this;

    _classCallCheck(this, DynamicRangeFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DynamicRangeFilter).call(this, props));
    _this.sliderUpdate = _this.sliderUpdate.bind(_assertThisInitialized(_this));
    _this.sliderUpdateAndSearch = _this.sliderUpdateAndSearch.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DynamicRangeFilter, [{
    key: "defineAccessor",
    value: function defineAccessor() {
      var _this$props = this.props,
          id = _this$props.id,
          title = _this$props.title,
          field = _this$props.field,
          fieldOptions = _this$props.fieldOptions,
          rangeFormatter = _this$props.rangeFormatter,
          translations = _this$props.translations;
      return new DynamicRangeAccessor(id, {
        id: id,
        title: title,
        field: field,
        fieldOptions: fieldOptions,
        rangeFormatter: rangeFormatter,
        translations: translations
      });
    }
  }, {
    key: "defineBEMBlocks",
    value: function defineBEMBlocks() {
      var block = this.props.mod || "sk-dynamic-range-filter";
      return {
        container: block,
        labels: block + "-value-labels"
      };
    }
  }, {
    key: "getMinMax",
    value: function getMinMax() {
      return {
        min: this.accessor.getStat("min") || 0,
        max: this.accessor.getStat("max") || 0
      };
    }
  }, {
    key: "sliderUpdate",
    value: function sliderUpdate(newValues) {
      var _this$getMinMax = this.getMinMax(),
          min = _this$getMinMax.min,
          max = _this$getMinMax.max;

      if (newValues.min == min && newValues.max == max) {
        this.accessor.state = this.accessor.state.clear();
      } else {
        this.accessor.state = this.accessor.state.setValue(newValues);
      }

      this.forceUpdate();
    }
  }, {
    key: "sliderUpdateAndSearch",
    value: function sliderUpdateAndSearch(newValues) {
      this.sliderUpdate(newValues);
      this.searchkit.performSearch();
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.accessor) return null;
      var _this$props2 = this.props,
          id = _this$props2.id,
          title = _this$props2.title,
          containerComponent = _this$props2.containerComponent;
      return renderComponent(containerComponent, {
        title: title,
        className: id ? "filter--".concat(id) : undefined,
        disabled: this.accessor.isDisabled()
      }, this.renderRangeComponent(this.props.rangeComponent));
    }
  }, {
    key: "renderRangeComponent",
    value: function renderRangeComponent(component) {
      var _this$getMinMax2 = this.getMinMax(),
          min = _this$getMinMax2.min,
          max = _this$getMinMax2.max;

      var rangeFormatter = this.props.rangeFormatter;
      var state = this.accessor.state.getValue();
      return renderComponent(component, {
        min: min,
        max: max,
        minValue: Number(get(state, "min", min)),
        maxValue: Number(get(state, "max", max)),
        rangeFormatter: rangeFormatter,
        onChange: this.sliderUpdate,
        onFinished: this.sliderUpdateAndSearch
      });
    }
  }]);

  return DynamicRangeFilter;
}(SearchkitComponent);
DynamicRangeFilter.propTypes = defaults({
  field: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  containerComponent: RenderComponentPropType,
  rangeComponent: RenderComponentPropType,
  rangeFormatter: PropTypes.func,
  fieldOptions: PropTypes.shape({
    type: PropTypes.oneOf(["embedded", "nested", "children"]).isRequired,
    options: PropTypes.object
  })
}, SearchkitComponent.propTypes);
DynamicRangeFilter.defaultProps = {
  containerComponent: Panel,
  rangeComponent: RangeSlider,
  rangeFormatter: identity
};